import { Dropdown, Stack, TextField } from 'braid-design-system';

import { EXPIRY_MONTHS } from '#shared/constants';

import type { ListingFieldValues } from './listingFieldUpdates';

type ListingFieldsProps = {
  listingId: string;
  fields: ListingFieldValues;
  errors?: Record<string, string>;
  onChange: (field: keyof ListingFieldValues, value: string) => void;
};

export const ListingFields = ({
  listingId,
  fields,
  errors = {},
  onChange,
}: ListingFieldsProps) => (
  <Stack space="small">
    <TextField
      id={`edit-name-${listingId}`}
      label="Name or business"
      value={fields.name}
      onChange={(e) => onChange('name', e.currentTarget.value)}
      message={errors.name}
      tone={errors.name ? 'critical' : undefined}
    />
    <TextField
      id={`edit-service-type-${listingId}`}
      label="Service type"
      value={fields.serviceType}
      onChange={(e) => onChange('serviceType', e.currentTarget.value)}
      message={
        errors.serviceType ??
        'This becomes a filter option on the directory once approved'
      }
      tone={errors.serviceType ? 'critical' : undefined}
    />
    <TextField
      id={`edit-phone-${listingId}`}
      label="Phone"
      value={fields.phone}
      onChange={(e) => onChange('phone', e.currentTarget.value)}
      message={errors.phone ?? errors.contact}
      tone={errors.phone || errors.contact ? 'critical' : undefined}
      inputMode="tel"
    />
    <TextField
      id={`edit-email-${listingId}`}
      label="Email"
      value={fields.email}
      onChange={(e) => onChange('email', e.currentTarget.value)}
      message={errors.email}
      tone={errors.email ? 'critical' : undefined}
      inputMode="email"
    />
    <TextField
      id={`edit-website-${listingId}`}
      label="Website"
      value={fields.website}
      onChange={(e) => onChange('website', e.currentTarget.value)}
      message={errors.website}
      tone={errors.website ? 'critical' : undefined}
    />
    <TextField
      id={`edit-blurb-${listingId}`}
      label="Description"
      value={fields.blurb}
      onChange={(e) => onChange('blurb', e.currentTarget.value)}
      message={errors.blurb}
      tone={errors.blurb ? 'critical' : undefined}
    />
    <Dropdown
      id={`edit-expiry-months-${listingId}`}
      label="Listing duration"
      value={fields.expiryMonths}
      onChange={(e) => onChange('expiryMonths', e.currentTarget.value)}
      message={
        errors.expiryMonths ??
        'The listing is removed automatically after this period from submission'
      }
      tone={errors.expiryMonths ? 'critical' : undefined}
    >
      {EXPIRY_MONTHS.map((months) => (
        <option key={months} value={months}>
          {months} months
        </option>
      ))}
    </Dropdown>
  </Stack>
);
